/**
 * A raiz do SPA (`/`) nao tem tela propria: ela manda para "Hoje", o primeiro item do menu.
 *
 * Ela e **interna**, e nao publica, e por isso vive sob o layout protegido: quem chega em `/`
 * sem sessao passa pela guarda antes deste redirecionamento e vai parar em `/entrar`. Fosse
 * publica, o visitante seria mandado para `/hoje` so para tomar o redirecionamento de la — uma
 * ida e volta a mais para chegar no mesmo lugar.
 *
 * A lista provisoria de `/health` que morava aqui saiu: `e2e/fumaca.spec.ts` ja confere os seis
 * servicos pelo gateway, que e onde essa checagem pertence.
 */

import { createRoute, redirect } from '@tanstack/react-router'

import { rotaDaAplicacao } from './aplicacao'

export const rotaInicio = createRoute({
  getParentRoute: () => rotaDaAplicacao,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/hoje' })
  },
})
